/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PigCreateDto } from '../../models/pig-create-dto';
import { PigDto } from '../../models/pig-dto';

export interface PigControllerCreate$Params {
      body: PigCreateDto
}

export function pigControllerCreate(http: HttpClient, rootUrl: string, params: PigControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<PigDto>> {
  const rb = new RequestBuilder(rootUrl, pigControllerCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PigDto>;
    })
  );
}

pigControllerCreate.PATH = '/api/pig';
